import {create} from 'zustand';
import * as authApi from '../api/auth';

// Not persisted: the session lives in the httpOnly cookie, not localStorage.
// fetchMe() re-hydrates `user` from that cookie on app load (see App.js).
export const useAuthStore = create((set) => ({
    user: null,
    status: 'idle', // 'idle' | 'loading' | 'ready'
    error: null,

    fetchMe: async () => {
        set({status: 'loading'});
        try {
            const user = await authApi.fetchMe();
            set({user, status: 'ready'});
        } catch (err) {
            set({user: null, status: 'ready'});
        }
    },

    login: async (credentials) => {
        set({error: null});
        try {
            const user = await authApi.login(credentials);
            set({user});
            return user;
        } catch (err) {
            set({error: err.message});
            throw err;
        }
    },

    register: async (details) => {
        set({error: null});
        try {
            const user = await authApi.register(details);
            set({user});
            return user;
        } catch (err) {
            set({error: err.message});
            throw err;
        }
    },

    logout: async () => {
        try {
            await authApi.logout();
        } finally {
            set({user: null});
        }
    },
}));
